import { css } from '@emotion/react'

export const root = css`
  font-size: inherit;
`

export const text = css`
  font-size: 12px;
  font-weight: 500;
`
